<script>
  import { navigate } from '../svelte-navigator';
</script>

<div class="e404">
  <div class="huge">404</div>
  <div>
    Page not found
    <button on:click="{() => navigate(-1)}">Go back</button>
  </div>
</div>


<style>
  .e404 {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }

  .huge {
    font-size: 10rem;
  }

  button {
    margin-left: 10px;
  }
</style>